import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/app/vehicle-detail/components/VehicleDetailInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/common/Header.tsx");
